module.exports = __webpack_public_path__ + "static/media/SpringVille_PH1_3.e0206b7b.webp";